import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Stack } from "@mui/material";
import { addWorkspace } from "../../api";
import { useFetchAppId } from "../../hook";
import { NoteBlockContainer, NotePageContainer } from "../note";
import { StaticHtmlBlock } from "../staticHtmlBlock";

export const NoWorkspacePage: React.FC = () => {
  const { user } = useAuth0();
  const email = user?.email!;
  const fetchAppId = useFetchAppId();

  const initWorkspace = () => {
    const appName = `${email} workspace`;
    addWorkspace({ ownerEmail: email, appName, ownerName: email }).then(
      () => {
        fetchAppId();
      }
    );
  };

  return (
    <Stack gap={3}>
      <NotePageContainer pageName="Welcome to OmegaAI">
        <StaticHtmlBlock
          html="<p>OmegaAI is a collaborative workspace for data exploration, AI-assisted querying, and building live data products. Everything you need — from raw data to published pages — lives in one place.</p>"
        />
        <StaticHtmlBlock
          name="Workspace"
          html="<p>A <strong>workspace</strong> is your private OmegaAI environment. It holds your notebook pages, database views, data connectors, and team members. Each workspace has its own data and subscription — you can be a member of multiple workspaces and switch between them in settings.</p>"
        />
        <StaticHtmlBlock
          name="Page"
          html="<p><strong>Notebook pages</strong> let you write, query, and display data side by side. Use the AI panel (the sparkle button, bottom-right) to query your data in plain English, generate transformations, or explore unfamiliar datasets. Pages can be published publicly or kept private to your workspace.</p>"
        />
        <StaticHtmlBlock
          name="Implementation"
          html="<p><strong>Connectors</strong> bring your external data sources in. Pull connectors sync data from APIs and databases into your workspace on a schedule. Push connectors let external services write data directly to OmegaAI.</p>"
        />
      </NotePageContainer>

      <NotePageContainer pageName="Start Your Free Trial">
        <StaticHtmlBlock
          html="<p>Your first 30 days are completely free — no credit card required. You can add a payment method at any time from your subscription settings. Trials include full access to all features.</p>"
        />
        <NoteBlockContainer>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box>No workspaces are associated with this account yet.</Box>
            <Box>
              <Button variant="contained" onClick={() => initWorkspace()}>
                Start Free Trial
              </Button>
            </Box>
          </Box>
        </NoteBlockContainer>
      </NotePageContainer>
    </Stack>
  );
};
